module.exports = __webpack_public_path__ + "static/media/ht11.d19798f6.png";